import React, { useState } from "react"
import { MdOutlineCloudOff, MdOutlineCloud } from "react-icons/md"
import { TbClock } from "react-icons/tb"
import { PiGraduationCapBold } from "react-icons/pi"
import BodyText from "../text/body-text/body-text"
import Heading from "../text/heading/heading"
import {getCourseNameFromEnum, getLearningModeFromEnum} from '../../utils/course'
import * as styles from './CourseCard.module.css'

const CourseCard = ({
  img,
  title,
  offlineText,
  duration,
  tag,
  graduationType,
}) => {
  const learningMode = getLearningModeFromEnum(offlineText);
  return (
    <>
      <div className={`${styles.cardOne} ${styles.front} `}>
        {/* Dynamic Content */}
        {img}

        <div className={`${styles.texts} py-2`}>
          <div className="flex text-[#4559ED] font-bold gap-1 items-center">
            <PiGraduationCapBold />
            <BodyText variant="bodyText6">{getCourseNameFromEnum(graduationType)}</BodyText>
          </div>
          <BodyText
            className="text-center line-clamp-3 flex-1 flex "
            variant="bodyText6"
          >
            <span className="line-clamp-3" dangerouslySetInnerHTML={{ __html: title }} />
          </BodyText>
          <div className={styles.flexCard}>
            <div className={`${styles.chip} ${styles.yellowChip}`}>
              {learningMode && learningMode != 'Offline' ?
                <MdOutlineCloud className="icon" />
                :
                <MdOutlineCloudOff className="icon" />
              }
              <BodyText variant="bodyText7">{learningMode}</BodyText>
            </div>
            <div className={`${styles.chip} ${styles.blueChip}`}>
              <TbClock className="icon" />
              <BodyText variant="bodyText7">{duration}</BodyText>
            </div>
          </div>

          {tag && (
            <>
              <div
                className="absolute bg-[#557DFD] w-[10px] h-[10px] right-[-10px] top-[20px] z-20"
                style={{
                  clipPath: "polygon(0 0, 0 100%, 100% 100%)",
                }}
              ></div>
              <div className="absolute top-[30px] right-[-10px] bg-[#2D4181] text-white capitalize py-1 px-4 rounded-bl-xl rounded-tl-xl z-20">
                <BodyText variant="bodyText8">{tag}</BodyText>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  )
}

export default CourseCard
